import { GetFilterPageReq, GetFilterPageRsp } from '@/types/filterPage';
import { ApiResponse, post } from './api';
import { API_PATHS } from './apiPaths';

export async function getFilterPageData(body?: GetFilterPageReq, params?: any): Promise<ApiResponse<GetFilterPageRsp>> {
  return await post(API_PATHS.GetFilterPage, body, { params });
}
